// @ts-nocheck
/* eslint-disable */
export const asNoovaLogoIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.28571 5H2V18.1429H6.28571V5ZM6.57143 5H11.5714L16.6488 13.7378C16.9421 14.2425 17.7143 14.0345 17.7143 13.4507V5H22V13.4153C22 18.3662 15.4601 20.1437 12.954 15.874L6.57143 5Z" fill="currentColor"/></svg>`,
    name: 'noova-logo' as const
};